module.exports = __webpack_public_path__ + "fonts/icomoon.4488491.eot";